// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShoppingCartItem_product__zAkEx {
  min-width: 610px;
}
.ShoppingCartItem_product__zAkEx p {
  margin: 0;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_header__vODRg {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 24px;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB {
  display: flex;
  justify-content: space-between;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_image__CACuQ {
  width: 140px;
  height: 140px;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_properties__WECGn {
  display: flex;
  width: 55%;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_properties__WECGn img {
  margin-right: 27px;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_properties__WECGn .ShoppingCartItem_properties-title__ZfyN5 {
  font-size: 18px;
  font-weight: bold;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_properties__WECGn .ShoppingCartItem_property__H3gbC {
  font-size: 16px;
  color: #616c7a;
  line-height: 24px;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_options__WthTx {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_options__WthTx .ShoppingCartItem_quantity-wrapper__1iND2 {
  display: block;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_options__WthTx .ShoppingCartItem_quantity-wrapper__1iND2 .ShoppingCartItem_unit-container__5Gb0u {
  display: flex;
  align-items: center;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_options__WthTx .ShoppingCartItem_quantity-wrapper__1iND2 input {
  height: 40px;
  border: solid 1px #666666;
  border-radius: 4px;
  padding: 9px;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_options__WthTx .ShoppingCartItem_buttons-wrapper__Pmqry {
  display: flex;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_options__WthTx .ShoppingCartItem_icon__Haz-j {
  font-size: 16px;
}
.ShoppingCartItem_product__zAkEx .ShoppingCartItem_body__oSOeB .ShoppingCartItem_options__WthTx Button {
  font-size: 16px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/views/ShoppingCart/ShoppingCartItem/ShoppingCartItem.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAEE;EACE,SAAA;AAAJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eCPO;EDQP,iBCLG;EDMH,mBAAA;AAAJ;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,YAAA;EACA,aAAA;AACN;AACI;EACE,aAAA;EACA,UAAA;AACN;AAAM;EACE,kBAAA;AAER;AAAM;EACE,eC1BI;ED2BJ,iBCvBD;ADyBP;AAAM;EACE,eC/BC;EDgCD,cE1BA;EF2BA,iBAAA;AAER;AACI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;AACN;AAAM;EACE,cAAA;AAER;AADQ;EACE,aAAA;EACA,mBAAA;AAGV;AADQ;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAGV;AAAM;EACE,aAAA;AAER;AAAM;EACE,eC1DC;AD4DT;AAAM;EACE,eC7DC;ED8DD,uBAAA;EAAA,kBAAA;EACA,UAAA;EACA,iBAAA;AAER","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n.product {\n  min-width: 610px;\n  p {\n    margin: 0;\n  }\n  .header {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n    margin-bottom: 24px;\n  }\n  .body {\n    display: flex;\n    justify-content: space-between;\n    .image {\n      width: 140px;\n      height: 140px;\n    }\n    .properties {\n      display: flex;\n      width: 55%;\n      img {\n        margin-right: 27px;\n      }\n      .properties-title {\n        font-size: typography.$header-xs;\n        font-weight: typography.$bold;\n      }\n      .property {\n        font-size: typography.$body-l;\n        color: colors.$light;\n        line-height: 24px;\n      }\n    }\n    .options {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n      justify-content: space-between;\n      .quantity-wrapper {\n        display: block;\n        .unit-container {\n          display: flex;\n          align-items: center;\n        }\n        input {\n          height: 40px;\n          border: solid 1px #666666;\n          border-radius: 4px;\n          padding: 9px;\n        }\n      }\n      .buttons-wrapper {\n        display: flex;\n      }\n      .icon {\n        font-size: typography.$body-l;\n      }\n      Button {\n        font-size: typography.$body-l;\n        width: fit-content;\n        padding: 0;\n        margin-left: auto;\n      }\n    }\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product": `ShoppingCartItem_product__zAkEx`,
	"header": `ShoppingCartItem_header__vODRg`,
	"body": `ShoppingCartItem_body__oSOeB`,
	"image": `ShoppingCartItem_image__CACuQ`,
	"properties": `ShoppingCartItem_properties__WECGn`,
	"properties-title": `ShoppingCartItem_properties-title__ZfyN5`,
	"property": `ShoppingCartItem_property__H3gbC`,
	"options": `ShoppingCartItem_options__WthTx`,
	"quantity-wrapper": `ShoppingCartItem_quantity-wrapper__1iND2`,
	"unit-container": `ShoppingCartItem_unit-container__5Gb0u`,
	"buttons-wrapper": `ShoppingCartItem_buttons-wrapper__Pmqry`,
	"icon": `ShoppingCartItem_icon__Haz-j`
};
export default ___CSS_LOADER_EXPORT___;
